export const TOKEN_KEY = 'auth_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const USER_KEY = 'auth_user';
export const IMPERSONATION_KEY = 'impersonated_merchant';

export function readImpersonation(): string | null {
  const session = sessionStorage.getItem(IMPERSONATION_KEY);
  if (session) return session;
  // One-time move from the old shared key so a refresh after deploy keeps
  // the current tab's merchant and stops leaking it to other tabs.
  const legacy = localStorage.getItem(IMPERSONATION_KEY);
  if (legacy) {
    sessionStorage.setItem(IMPERSONATION_KEY, legacy);
    localStorage.removeItem(IMPERSONATION_KEY);
  }
  return legacy;
}

export function writeImpersonation(value: string | null) {
  if (value) {
    sessionStorage.setItem(IMPERSONATION_KEY, value);
  } else {
    sessionStorage.removeItem(IMPERSONATION_KEY);
  }
  localStorage.removeItem(IMPERSONATION_KEY);
}

export function clearAuthStorage() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  writeImpersonation(null);
}

let redirectInFlight = false;

// Full page reload is the clean way to tear down Apollo caches,
// pending queries, and any component state that assumed a logged-in user.
// The in-flight guard keeps parallel failed queries from each kicking off
// their own navigation and flooding the console.
export function clearSessionAndRedirect(reason: string, { sessionExpired = true } = {}) {
  if (redirectInFlight) return;
  redirectInFlight = true;
  console.log(`[Auth] ${reason}, clearing authentication`);
  clearAuthStorage();
  window.location.href = sessionExpired ? '/login?session_expired=1' : '/login';
}
